import React,{useState,useEffect}  from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
// import Breadcrumb from '../../components/Breadcrumb/CourseBreadcrumbs';
import CourseDetailsMain from './CourseDetailsMain';
import ScrollToTop from '../../components/ScrollTop';
import courses from '../../data/Courses.json';
import Breadcrumb from '../../components/Breadcrumb/index.js'

import Logo from '../../assets/images/logos/logo2.png';
import FooterTwo from '../../components/Footer/FooterTwo.js';
import CourseService from '../../services/course.service.js';

const CourseDetails = () => {
    const [courseDetail,setCourseDetail]=useState({});



    const location = useLocation();
    const slug = location.pathname.split('/')[2]; 
    
    // const course = courses.find((b) => b.id === Number(1));
    // const flatPrice = course.price.split('.');
    // const flatPriceRegular = course.regularPrice.split('.');

    useEffect(()=>{
        CourseService.details(slug)
        .then(res=>setCourseDetail(res.data))
        .catch(err=>console.log(err));

    },[]);

    return (
        <body className="course-single">
            <Header
                parentMenu='course'
                menuCategoryEnable='enable'
                // headerNormalLogo={Logo}
                // headerStickyLogo={Logo}
            />
            <Breadcrumb pageTitle={courseDetail?.title}/>


            <div class="react-wrapper">

                <div class="react-wrapper-inner">
                    {/* <Breadcrumb
                        courseBannerImg= {`${course.bannerImg}`}
                        courseTitle= {course.title}
                        courseName= {course.name}
                        courseAuthor= {course.author}
                        courseAuthorImg= {course.authorImg}
                        courseLesson= {course.lesson}
                        courseEnrolled= {course.enrolled}
                    /> */}
                    

                    <CourseDetailsMain
                        courseDetail={courseDetail}
                        // courseID={course.id}
                        // courseImg= {`${course.image}`}
                        // courseTitle= {course.title}
                        // courseName= {course.name}
                        // courseAuthor= {course.author}
                        // courseAuthorImg= {course.authorImg}
                        // courseLesson= {course.lesson}
                        // courseDuration= {course.duration}
                        // courseEnrolled= {course.enrolled}
                        // coursePrice= {flatPrice[0]}
                        // courseRegularPrice= {flatPriceRegular[0]}
                        // courseLanguage= {course.language}
                    />

                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            {/* <Footer /> */}
            <FooterTwo/>

        </body>
    );
}

export default CourseDetails;